import { render } from "./Unauthorized.vue?vue&type=template&id=14fbb5ff&name=unauthorized"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__